import type { AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'
import type { DemandGroupDirectoryEntry } from '@ebalance/proto/bffuser/v1/demand_group_service_pb'

/**
 * 目録からエリアの行だけを取り出す表示フィルタ。並び (エリア, 小売コード, グループ名)
 * は backend が決めた順を保つ。
 */
export function entriesInArea(
  entries: readonly DemandGroupDirectoryEntry[],
  area: AreaCode | undefined,
): DemandGroupDirectoryEntry[] {
  if (area === undefined) return []
  return entries.filter((entry) => entry.area === area)
}

/** 小売の表示。事業者マスタに無ければ (名が unset) 事業者コード。 */
export function retailerLabel(entry: DemandGroupDirectoryEntry): string {
  return entry.retailerName ?? entry.retailerCode
}
